import { TUser } from "@cockpitai/integration/auth/types";

declare global {
  interface Window {
    gtag: (command: string, action: string, params?: Record<string, any>) => void;
  }
}

interface AnalyticsEventParams extends Record<string, any> {
  user_name?: string;
  user_std_code?: string;
}

export const sendAnalyticsEvent = async (
  eventName: string,
  eventParams: AnalyticsEventParams = {}
) => {
  let userData: TUser = {} as TUser;

  const userStorage = await localStorage.getItem('@cockpitia-session');
  if(userStorage) {
    const { state: { user } } = JSON.parse(userStorage);
    userData = user;
  }

  const enrichedParams = {
    ...eventParams,
    user_name: userData?.name ?? '',
    user_std_code: userData?.std_code ?? '',
    event_timestamp: new Date().toISOString()
  };

  if (window.gtag) {
    window.gtag('event', eventName, enrichedParams);
  }
};
